import { HeroImage } from "./HeroImage";
import type { HeroImageProps } from "./HeroImage.d";

export { HeroImage };
export type { HeroImageProps };
